import { OnboardingRegistrationAddressFormType } from 'modules/onboarding/common/forms/onboardingRegistrationAddressForm';
import { useClientRegistrationAddress } from 'modules/onboarding/common/hooks';

import { useOnboardingContext } from '../useOnboardingContext';

export const useRegistrationAddress = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();

  const {
    countries,
    countriesLoading,
    initialValues,
    submitLoading,
    files,
    submitDisabled,
    onSubmit,
    onAddFiles,
    onRemoveFile,
  } = useClientRegistrationAddress(data);

  const handleSubmit = async (
    values: OnboardingRegistrationAddressFormType
  ) => {
    if (values) {
      await onSubmit(values);
      goToNext();
    }
  };

  return {
    initialValues,
    countries,
    countriesLoading,
    submitLoading,
    files,
    submitDisabled,
    onSubmit: handleSubmit,
    goToBack,
    onAddFiles,
    onRemoveFile,
  };
};
